import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { useValidateDocumentMutation } from 'api/main';
import { validationStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { CustomButton, CustomTextField } from 'components';
import { Box } from '@mui/material';

const CommentSection = ({ doc }) => {
    const [rejectedComment, setRejectedComment] = useState(doc.validationComment || '');
    const [validateDocument, { isLoading: validationLoader }] = useValidateDocumentMutation();

    const handleRejectedCommentChange = useCallback(e => {
        setRejectedComment(e.target.value);
    }, []);

    const handleRejectDocument = useCallback(() => {
        const payload = {
            validationStatus: validationStatus.REJECTED,
            validationComment: rejectedComment,
        };
        validateDocument({ id: doc.id, ...payload });
    }, [validateDocument, doc.id, rejectedComment]);

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} paddingY={1}>
            <CustomTextField
                sx={{
                    width: '70%',
                    margin: 0,
                }}
                value={rejectedComment}
                onChange={handleRejectedCommentChange}
            />
            <CustomButton
                noMargin
                label={texts.SAVE_AND_CONTINUE}
                sx={{ flex: '1 0' }}
                onClick={handleRejectDocument}
                disabled={validationLoader}
                loading={validationLoader}
            />
        </Box>
    );
};

CommentSection.propTypes = {
    doc: PropTypes.object.isRequired,
};

export default CommentSection;
